export const ACCOUNT_MENU_LABELS = {
  'edit-profile': 'Edit Profile',
  appearance: 'Appearance',
  'invite-friends': 'Invite Friends',
} as const;

export type AccountMenuShortcut = keyof typeof ACCOUNT_MENU_LABELS;
export const DEFAULT_ACCOUNT_MENU: AccountMenuShortcut[] = [
  'edit-profile',
  'appearance',
  'invite-friends',
];

/** The ordered list contains only visible optional shortcuts. Core actions are never stored. */
export function normalizeAccountMenu(value: unknown): AccountMenuShortcut[] {
  if (!Array.isArray(value)) return [...DEFAULT_ACCOUNT_MENU];
  return [
    ...new Set(
      value.filter(
        (key): key is AccountMenuShortcut =>
          typeof key === 'string' && Object.hasOwn(ACCOUNT_MENU_LABELS, key),
      ),
    ),
  ];
}
